module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("224 Blocks")]), _vm._v(" "), _c('h2', [_vm._v("Running Efficiency")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "font-size": "4rem"
    }
  }, [_vm._v(_vm._s(isFinite(_vm.runningEfficiency) ? _vm.runningEfficiency : "0.0") + "%")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalBlocks) + " / 224")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Category Breakdown")]), _vm._v(" "), _c('div', {
    staticClass: "breakdowns"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.categorySummaries), function(category) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "block",
      class: _vm.categories[category.id].color
    }), _vm._v("\n          " + _vm._s(_vm.categories[category.id].name) + " (" + _vm._s(category.count) + ")\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "percent"
    }, [_vm._v(_vm._s(Math.round((1000 * category.count) / category.quota) / 10) + "%")]), _vm._v(" "), _c('td', {
      staticClass: "percent"
    }, [_vm._v(_vm._s(Math.round((1000 * category.count) / _vm.allBlocks.length) / 10) + "%")]), _vm._v(" "), _c('td', {
      staticClass: "percent"
    }, [_vm._v(_vm._s(Math.round((1000 * category.count) / 224) / 10) + "%")])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "percent"
  }, [_vm._v("Quota")]), _vm._v(" "), _c('th', {
    staticClass: "percent"
  }, [_vm._v("|Blocks|")]), _vm._v(" "), _c('th', {
    staticClass: "percent"
  }, [_vm._v("Week")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d61151a!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/RealtimeView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7d61151a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/RealtimeView.vue
// module chunks = 0